import { Star } from 'lucide-react';
import {
  TypographyH2,
  TypographyP,
  TypographyBlockquote,
  TypographyLarge,
} from './ui/typography';

const TESTIMONIALS = [
  {
    id: 1,
    name: "Sarah Johnson",
    initials: "SJ",
    content: "The flowers were absolutely stunning and arrived right on time. The florist even called to confirm the delivery details. Exceptional service!",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    initials: "MC",
    content: "I've been using MarketBloom for all my flower deliveries. The quality is consistently excellent, and the local florists are true artists.",
    rating: 5
  },
  {
    id: 3,
    name: "Emma Wilson",
    initials: "EW",
    content: "As an event planner, I need reliable florists. MarketBloom has never disappointed. Their network of local florists is outstanding.",
    rating: 5
  }
];

// Avatar colors for each testimonial
const avatarColors = [
  'bg-blue-500',
  'bg-green-500', 
  'bg-purple-500'
];

export function Testimonials() {
  return (
    <section className="w-full py-20 bg-neutral-50">
      <div className="max-w-[1440px] mx-auto px-6">
        <div className="text-left mb-12">
          <h2 className="text-4xl md:text-5xl font-semibold text-brand-secondary tracking-tight satoshi-font mb-3">
            What Our Customers Say
          </h2>
          <p className="text-neutral-600 text-[15px] max-w-2xl satoshi-font">
            Read about experiences from our happy customers across Sydney
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((testimonial, index) => (
            <div 
              key={testimonial.id}
              className="bg-white rounded-lg p-8 border border-neutral-200 hover:border-neutral-300 transition-all duration-200 flex flex-col"
            >
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star 
                    key={i}
                    className="w-5 h-5 fill-[brand-primary] text-brand-primary"
                  />
                ))}
              </div>

              {/* Content */}
              <p className="text-neutral-700 mb-6 text-base leading-relaxed flex-grow satoshi-font italic">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-neutral-100 mt-auto">
                <div 
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm ${avatarColors[index]}`}
                >
                  {testimonial.initials}
                </div>
                <div>
                  <div className="font-semibold text-brand-secondary satoshi-font">
                    {testimonial.name}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 